import { Skeleton, SkeletonText, VStack } from "@chakra-ui/react";
import React from "react";

const EssentialProductCardSkeleton = () => {
  return (
    <VStack
      spacing="8px"
      align="start"
      w="full"
      border="1px solid #E2E8F0"
      rounded="md"
      p="12px"
    >
      {/* Gambar Produk */}
      <Skeleton w="full" h="160px" rounded="md" />

      {/* Kategori Produk */}
      <SkeletonText noOfLines={1} skeletonHeight="12px" w="50%" />

      {/* Nama Produk */}
      <SkeletonText noOfLines={1} skeletonHeight="16px" w="full" />

      {/* Harga Produk */}
      <SkeletonText noOfLines={1} skeletonHeight="20px" w="40%" />
    </VStack>
  );
};

export default EssentialProductCardSkeleton;
